import ChecklistBoard from "@/pages/hrms/ChecklistBoard";

export default function Offboarding() {
  return <ChecklistBoard type="offboarding" title="Offboarding" subtitle="Track a clean, compliant exit for departing employees." />;
}
